import { render, staticRenderFns } from "./audit_details.vue?vue&type=template&id=054de6a1&scoped=true&"
import script from "./audit_details.vue?vue&type=script&lang=js&"
export * from "./audit_details.vue?vue&type=script&lang=js&"
import style0 from "./audit_details.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./audit_details.vue?vue&type=style&index=1&id=054de6a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054de6a1",
  null
  
)

component.options.__file = "audit_details.vue"
export default component.exports